var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.trial_ends_at)?_c('div',{staticClass:"trial-left-container",on:{"click":_vm.goToSelectPlan}},[_c('span',[_vm._v(" "+_vm._s(_vm.daysOfTrialLeft)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }